module.exports = __webpack_public_path__ + "static/media/127-video-camera.6b7bf1fd.svg";